import script from "./CompaniesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CompaniesComponent.vue?vue&type=script&setup=true&lang=js"

import "./CompaniesComponent.vue?vue&type=style&index=0&id=076489c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-076489c8"]])

export default __exports__